// A first-class Share affordance for a session.
//
// Deliberately not folded into CopySessionMenu, even though that file is the
// single home for the session *exports*. Copy Summary and Copy Session Plan
// both put text on your own clipboard; sharing publishes a link for someone
// else. Hiding the third behind a button labelled "Copy" meant nobody would
// find it, so the split here is by what the action does to the user's intent,
// not by which code module the handlers happen to live in.

import React, { useState } from "react";
import { Share2 } from "lucide-react";
import { Button } from "../ui/button";
import ShareLinkDialog from "./ShareLinkDialog";

const ShareSessionButton = ({
  plan,
  // Present when this is a saved history row: lets the server snapshot the
  // share from the stored session and keep a breadcrumb back to it.
  sessionId,
  iconOnly = false,
  variant = "outline",
  size = "sm",
  className = "",
}) => {
  const [open, setOpen] = useState(false);

  if (!plan) return null;

  return (
    <>
      <Button
        variant={variant}
        size={size}
        className={`${iconOnly ? "h-8 w-8 p-0" : "gap-1.5"} shrink-0 ${className}`}
        onClick={() => setOpen(true)}
        title="Share this session"
        aria-label="Share this session"
      >
        <Share2 className="h-3.5 w-3.5" />
        {!iconOnly && "Share"}
      </Button>

      <ShareLinkDialog
        open={open}
        onOpenChange={setOpen}
        request={
          sessionId
            ? { kind: "session", workout_session_id: sessionId }
            : { kind: "plan", plan }
        }
        defaultTitle={plan?.label || ""}
      />
    </>
  );
};

export default ShareSessionButton;
